const OciBackgroundSearchCatalog = require('./types/OciBackgroundSearchCatalog');

module.exports = (app) => app.controller('ociBackgroundSearchResultController', /* @ngInject */ function ($scope, ociBackgroundSearchService) {
    $scope.init = init;

    /**
     * @type {OciBackgroundSearchCatalog[]}
     */
    $scope.catalogs = [];

    /**
     * Initializes the oci background search with the search query
     * @param searchQuery {string}
     */
    function init(searchQuery) {
        ociBackgroundSearchService.getCompatibleCatalogs().then((catalogs) => {
            if(catalogs) {
                $scope.catalogs = catalogs.map(catalog => new OciBackgroundSearchCatalog(ociBackgroundSearchService, catalog));
                $scope.catalogs.forEach(catalog => catalog.searchFor(searchQuery));
            }
            $scope.$apply();
        })
    }
});